// Formulários específicos por tipo de documento
export { default as ContestacaoForm } from './ContestacaoForm';
export { default as ReplicaForm } from './ReplicaForm';
export { default as ManifestacaoForm } from './ManifestacaoForm';
export { default as AlegacoesFinaisForm } from './AlegacoesFinaisForm';
export { default as AgravoInstrumentoForm } from './AgravoInstrumentoForm';
export { default as AgravoInternoForm } from './AgravoInternoForm';
export { default as RecursoEspecialForm } from './RecursoEspecialForm';
export { default as EmbargosDeclaracaoForm } from './EmbargosDeclaracaoForm';
export { default as CumprimentoSentencaForm } from './CumprimentoSentencaForm';
export { default as ApelacaoForm } from './ApelacaoForm';
export { default as EmbargosTerceiroForm } from './EmbargosTerceiroForm';
export { default as TutelaCautelarForm } from './TutelaCautelarForm';
export { default as TutelaAntecipadaForm } from './TutelaAntecipadaForm';
export { default as TutelaIncidentalForm } from './TutelaIncidentalForm';
export { default as TutelaEvidenciaForm } from './TutelaEvidenciaForm';
export { default as AdjudicacaoCompulsoriaForm } from './AdjudicacaoCompulsoriaForm';
export { default as SustacaoProtestoForm } from './SustacaoProtestoForm';
export { default as BuscaApreensaoMenorForm } from './BuscaApreensaoMenorForm';
export { default as EmendaInicialForm } from './EmendaInicialForm';
export { default as RecuperacaoJudicialForm } from './RecuperacaoJudicialForm';
export { default as MandadoSegurancaForm } from './MandadoSegurancaForm';
export { default as ExecucaoTituloExtrajudicialForm } from './ExecucaoTituloExtrajudicialForm';
export { default as ContrarrazoesApelacaoForm } from './ContrarrazoesApelacaoForm';
export { default as RecursoInominadoForm } from './RecursoInominadoForm';
export { default as ContrarrazoesRecursoInominadoForm } from './ContrarrazoesRecursoInominadoForm';
export { default as ContraminutaAgravoForm } from './ContraminutaAgravoForm';
export { default as ContraminutaAgravoInternoForm } from './ContraminutaAgravoInternoForm';
export { default as RecursoOrdinarioConstitucionalForm } from './RecursoOrdinarioConstitucionalForm';
export { default as MemoriaisRecursaisForm } from './MemoriaisRecursaisForm';
export { default as MemoriaisSTJForm } from './MemoriaisSTJForm';
export { default as ContrarrazoesREspForm } from './ContrarrazoesREspForm';
export { default as AgravoREspForm } from './AgravoREspForm';
export { default as ContraminutaAgravoREspForm } from './ContraminutaAgravoREspForm';
export { default as RecursoExtraordinarioForm } from './RecursoExtraordinarioForm';
export { default as ContrarrazoesREForm } from './ContrarrazoesREForm';
export { default as EmbargosDivergenciaForm } from './EmbargosDivergenciaForm';
export { default as ImpugnacaoEmbargosDivergenciaForm } from './ImpugnacaoEmbargosDivergenciaForm';
export { default as ContrarrazoesEmbargosDeclaracaoForm } from './ContrarrazoesEmbargosDeclaracaoForm';
export { default as ImpugnacaoCumprimentoSentencaForm } from './ImpugnacaoCumprimentoSentencaForm';
export { default as EmbargosExecucaoForm } from './EmbargosExecucaoForm';
export { default as ImpugnacaoEmbargosExecucaoForm } from './ImpugnacaoEmbargosExecucaoForm';
export { default as EmbargosMonitoriaForm } from './EmbargosMonitoriaForm';
export { default as ExcecaoPreExecutividadeForm } from './ExcecaoPreExecutividadeForm';
export { default as ImpugnacaoPenhoraForm } from './ImpugnacaoPenhoraForm';
export { default as ImpugnacaoHomologacaoCalculosForm } from './ImpugnacaoHomologacaoCalculosForm';
export { default as PedidoLevantamentoValoresForm } from './PedidoLevantamentoValoresForm';
export { default as PedidoPenhoraFaturamentoForm } from './PedidoPenhoraFaturamentoForm';
export { default as PedidoPenhoraRostoAutosForm } from './PedidoPenhoraRostoAutosForm';
export { default as PedidoExpedicaoRPVForm } from './PedidoExpedicaoRPVForm';
export { default as AcaoRescissoriaForm } from './AcaoRescissoriaForm';
export { default as AcordoJudicialExtincaoForm } from './AcordoJudicialExtincaoForm';
export { default as AcordoDivorcioForm } from './AcordoDivorcioForm';
export { default as AcordoAlimentosGuardaForm } from './AcordoAlimentosGuardaForm';
export { default as CumprimentoProvisorioForm } from './CumprimentoProvisorioForm';
export { default as ImpugnacaoCreditoLiquidacaoForm } from './ImpugnacaoCreditoLiquidacaoForm';
export { default as HabilitacaoCreditoRetardatariaForm } from './HabilitacaoCreditoRetardatariaForm';
export { default as HabilitacaoCreditoAdministrativaForm } from './HabilitacaoCreditoAdministrativaForm';
export { default as AdaptarModeloForm } from './AdaptarModeloForm';

// ========================================
// FORMULÁRIOS TRABALHISTAS
// ========================================
export { default as ReclamacaoTrabalhistaForm } from './ReclamacaoTrabalhistaForm';
export { default as ContestacaoTrabalhistaForm } from './ContestacaoTrabalhistaForm';
export { default as ReplicaTrabalhistaForm } from './ReplicaTrabalhistaForm';
export { default as RecursoOrdinarioTrabalhistaForm } from './RecursoOrdinarioTrabalhistaForm';
export { default as ContrarrazoesROTrabalhistaForm } from './ContrarrazoesROTrabalhistaForm';
export { default as AgravoPeticaoForm } from './AgravoPeticaoForm';
export { default as RecursoAdesivoForm } from './RecursoAdesivoForm';
export { default as RecursoRevistaForm } from './RecursoRevistaForm';
export { default as EmendaInicialTrabalhistaForm } from './EmendaInicialTrabalhistaForm';
export { default as ManifestacaoProcessualTrabalhistaForm } from './ManifestacaoProcessualTrabalhistaForm';
export { default as QuesitosPericiaisTrabalhistaForm } from './QuesitosPericiaisTrabalhistaForm';
export { default as ConsignacaoPagamentoTrabalhistaForm } from './ConsignacaoPagamentoTrabalhistaForm';

// ========================================
// FORMULÁRIOS POR ÁREA
// ========================================
export * from './criminalForms';
export * from './previdenciarioForms';
export * from './transitoForms';
export * from './magistraturaForms';
export * from './recessoForms';
export * from './trabalhistaForms';
export * from './contratoForms';
export * from './extrajudicialForms';
export * from './GenericFormTemplate';

// Componentes compartilhados
export * from './shared';

// Mapeamento de tipos de documento para formulários específicos
export const FORM_TYPE_MAPPING: Record<string, string> = {
  // Contestação
  'contestacao_civel': 'contestacao',
  'contestacao_trabalhista': 'contestacao',
  
  // Réplica
  'replica_civel': 'replica',
  'replica_trabalhista': 'replica',
  
  // Manifestação
  'manifestacao_processual': 'manifestacao',
  
  // Alegações Finais
  'alegacoes_finais': 'alegacoes_finais',
  
  // Agravo de Instrumento
  'agravo_instrumento': 'agravo_instrumento',
  
  // Agravo Interno
  'agravo_interno': 'agravo_interno',
  
  // Recurso Especial
  'recurso_especial': 'recurso_especial',
  
  // Embargos de Declaração
  'embargos_declaracao': 'embargos_declaracao',
  
  // Cumprimento de Sentença
  'cumprimento_sentenca': 'cumprimento_sentenca',
  
  // Apelação
  'apelacao': 'apelacao',
  
  // Embargos de Terceiro
  'embargos_terceiro': 'embargos_terceiro',
  
  // Tutela Provisória
  'tutela_provisoria_cautelar': 'tutela_cautelar',
  'tutela_provisoria_antecipada': 'tutela_antecipada',
  'tutela_incidental': 'tutela_incidental',
  'tutela_evidencia': 'tutela_evidencia',
  // Iniciais
  'adjudicacao_compulsoria': 'adjudicacao_compulsoria',
  'sustacao_protesto': 'sustacao_protesto',
  'busca_apreensao_menor': 'busca_apreensao_menor',
  'emenda_inicial': 'emenda_inicial',
  'recuperacao_judicial': 'recuperacao_judicial',
  'mandado_seguranca': 'mandado_seguranca',
  'execucao_titulo_extrajudicial': 'execucao_titulo_extrajudicial',
  'contrarrazoes_apelacao': 'contrarrazoes_apelacao',
  'recurso_inominado': 'recurso_inominado',
  'contrarrazoes_recurso_inominado': 'contrarrazoes_recurso_inominado',
  'contraminuta_agravo': 'contraminuta_agravo',
  'contraminuta_agravo_interno': 'contraminuta_agravo_interno',
  'recurso_ordinario_constitucional': 'recurso_ordinario_constitucional',
  'memoriais_recursais': 'memoriais_recursais',
  'memoriais_stj': 'memoriais_stj',
  'contrarrazoes_resp': 'contrarrazoes_resp',
  'agravo_resp': 'agravo_resp',
  'contraminuta_agravo_resp': 'contraminuta_agravo_resp',
  'recurso_extraordinario': 'recurso_extraordinario',
  'contrarrazoes_re': 'contrarrazoes_re',
  'embargos_divergencia': 'embargos_divergencia',
  'impugnacao_embargos_divergencia': 'impugnacao_embargos_divergencia',
  'contrarrazoes_embargos_declaracao': 'contrarrazoes_embargos_declaracao',
  'impugnacao_cumprimento_sentenca': 'impugnacao_cumprimento_sentenca',
  'embargos_execucao': 'embargos_execucao',
  'impugnacao_embargos_execucao': 'impugnacao_embargos_execucao',
  'embargos_monitoria': 'embargos_monitoria',
  'excecao_pre_executividade': 'excecao_pre_executividade',
  'impugnacao_penhora': 'impugnacao_penhora',
  'impugnacao_homologacao_calculos': 'impugnacao_homologacao_calculos',
  'pedido_levantamento_valores': 'pedido_levantamento_valores',
  'pedido_penhora_faturamento': 'pedido_penhora_faturamento',
  'pedido_penhora_rosto_autos': 'pedido_penhora_rosto_autos',
  'pedido_expedicao_rpv': 'pedido_expedicao_rpv',
  'acao_rescissoria': 'acao_rescissoria',
  'acordo_judicial_extincao': 'acordo_judicial_extincao',
  'acordo_divorcio': 'acordo_divorcio_completo',
  'acordo_alimentos_guarda': 'acordo_alimentos_guarda_visitas',
  'cumprimento_provisorio': 'cumprimento_provisorio',
  'impugnacao_credito_liquidacao': 'impugnacao_credito_liquidacao',
  'habilitacao_credito_retardataria': 'habilitacao_credito_retardataria',
  'habilitacao_credito_administrativa': 'habilitacao_credito_administrativa',
  'adaptar_modelo': 'adaptar_modelo',
  
  // ========================================
  // TRABALHISTA
  // ========================================
  'reclamacao_trabalhista': 'reclamacao_trabalhista',
  'agravo_peticao': 'agravo_peticao',
  'recurso_ordinario_trabalhista': 'recurso_ordinario_trabalhista',
  'contrarrazoes_ro_trabalhista': 'contrarrazoes_ro_trabalhista',
  'recurso_revista': 'recurso_revista',
  'contrarrazoes_recurso_revista': 'contrarrazoes_recurso_revista',
  'acordo_extrajudicial_trabalhista': 'acordo_extrajudicial_trabalhista',
  'emenda_inicial_trabalhista': 'emenda_inicial_trabalhista',
  'manifestacao_trabalhista': 'manifestacao_trabalhista',
  'quesitos_periciais_trabalhista': 'quesitos_periciais_trabalhista',
  'consignacao_pagamento_trabalhista': 'consignacao_pagamento_trabalhista',
  'alegacoes_finais_trabalhista': 'alegacoes_finais_trabalhista',
  'embargos_declaracao_trabalhista': 'embargos_declaracao_trabalhista',
  'agravo_instrumento_trabalhista': 'agravo_instrumento_trabalhista',
  'mandado_seguranca_trabalhista': 'mandado_seguranca_trabalhista',
  'impugnacao_liquidacao_trabalhista': 'impugnacao_liquidacao_trabalhista',
  'excecao_incompetencia_trabalhista': 'excecao_incompetencia_trabalhista',
  'impugnacao_valor_causa_trabalhista': 'impugnacao_valor_causa_trabalhista',
  'acao_cumprimento_trabalhista': 'acao_cumprimento_trabalhista',
  'habeas_corpus_trabalhista': 'habeas_corpus_trabalhista',
  'agravo_regimental_trabalhista': 'agravo_regimental_trabalhista',
  'embargos_sdi_tst': 'embargos_sdi_tst',
  'memoriais_recursais_trabalhista': 'memoriais_recursais_trabalhista',
  'recurso_extraordinario_trabalhista': 'recurso_extraordinario_trabalhista',
  'contrarrazoes_re_trabalhista': 'contrarrazoes_re_trabalhista',
  'contraminuta_agravo_instrumento_trabalhista': 'contraminuta_agravo_instrumento_trabalhista',
  'contraminuta_agravo_resp_trabalhista': 'contraminuta_agravo_resp_trabalhista',
  'contrarrazoes_embargos_declaracao_trabalhista': 'contrarrazoes_embargos_declaracao_trabalhista',
  'acao_rescisoria_trabalhista': 'acao_rescisoria_trabalhista',
  'cumprimento_sentenca_trabalhista': 'cumprimento_sentenca_trabalhista',
  'impugnacao_cumprimento_sentenca_trabalhista': 'impugnacao_cumprimento_sentenca_trabalhista',
  'embargos_execucao_trabalhista': 'embargos_execucao_trabalhista',
  'impugnacao_embargos_execucao_trabalhista': 'impugnacao_embargos_execucao_trabalhista',
  'contrarrazoes_agravo_peticao': 'contrarrazoes_agravo_peticao',
  'recurso_ordinario_constitucional_trabalhista': 'recurso_ordinario_constitucional_trabalhista',
  'cumprimento_provisorio_sentenca_trabalhista': 'cumprimento_provisorio_sentenca_trabalhista',
  'impugnacao_homologacao_calculos_trabalhista': 'impugnacao_homologacao_calculos_trabalhista',
  'embargos_monitoria_trabalhista': 'embargos_monitoria_trabalhista',
  'pedido_penhora_faturamento_trabalhista': 'pedido_penhora_faturamento_trabalhista',
  'pedido_penhora_rosto_autos_trabalhista': 'pedido_penhora_rosto_autos_trabalhista',
  'pedido_expedicao_rpv_trabalhista': 'pedido_expedicao_rpv_trabalhista',
  'pedido_revisao_trabalhista': 'pedido_revisao_trabalhista',
  'contraminuta_agravo_interno_trabalhista': 'contraminuta_agravo_interno_trabalhista',
  'recurso_adesivo': 'recurso_adesivo',

  // ========================================
  // CRIMINAL / PENAL
  // ========================================
  'habeas_corpus': 'habeas_corpus',
  'queixa_crime': 'queixa_crime',
  'defesa_previa_criminal': 'defesa_previa_criminal',
  'resposta_acusacao': 'resposta_acusacao',
  'liberdade_provisoria': 'liberdade_provisoria',
  'recurso_sentido_estrito': 'recurso_sentido_estrito',
  'revisao_criminal': 'revisao_criminal',
  'alegacoes_finais_criminais': 'alegacoes_finais_criminais',
  'apelacao_criminal': 'apelacao_criminal',
  'pedido_progressao_regime': 'pedido_progressao_regime',
  'revogacao_prisao_preventiva': 'revogacao_prisao_preventiva',
  'revogacao_prisao_medidas': 'revogacao_prisao_medidas',
  'denuncia': 'denuncia',
  'emenda_inicial_criminal': 'emenda_inicial_criminal',
  'replica_criminal': 'replica_criminal',
  'excecao_suspeicao_criminal': 'excecao_suspeicao_criminal',
  'relaxamento_prisao': 'relaxamento_prisao',
  'revogacao_medidas_protetivas': 'revogacao_medidas_protetivas',
  'quesitos_periciais_criminal': 'quesitos_periciais_criminal',
  'manifestacao_processual_criminal': 'manifestacao_processual_criminal',
  'contrarrazoes_apelacao_criminal': 'contrarrazoes_apelacao_criminal',
  'contrarrazoes_rese': 'contrarrazoes_rese',
  'recurso_ordinario_constitucional_criminal': 'recurso_ordinario_constitucional_criminal',
  'memoriais_recursais_criminal': 'memoriais_recursais_criminal',
  'memoriais_stj_criminal': 'memoriais_stj_criminal',
  'recurso_especial_criminal': 'recurso_especial_criminal',
  'contrarrazoes_resp_criminal': 'contrarrazoes_resp_criminal',
  'agravo_resp_criminal': 'agravo_resp_criminal',
  'contraminuta_agravo_resp_criminal': 'contraminuta_agravo_resp_criminal',
  'recurso_extraordinario_criminal': 'recurso_extraordinario_criminal',
  'contrarrazoes_re_criminal': 'contrarrazoes_re_criminal',
  'embargos_declaracao_criminal': 'embargos_declaracao_criminal',
  'contrarrazoes_embargos_declaracao_criminal': 'contrarrazoes_embargos_declaracao_criminal',
  'restituicao_coisa_apreendida': 'restituicao_coisa_apreendida',
  'peticao_incidente_execucao': 'peticao_incidente_execucao',
  'agravo_execucao_penal': 'agravo_execucao_penal',
  'contrarrazoes_agravo_execucao': 'contrarrazoes_agravo_execucao',
  'livramento_condicional': 'livramento_condicional',
  'indulto_natalino': 'indulto_natalino',
  'peca_modelo_criminal': 'peca_modelo_criminal',

  // ========================================
  // PREVIDENCIÁRIO
  // ========================================
  'concessao_beneficio': 'concessao_beneficio',
  'revisao_beneficio': 'revisao_beneficio',
  'recurso_especial_previdenciario': 'recurso_especial_previdenciario',
  'recurso_ordinario_previdenciario': 'recurso_ordinario_previdenciario',
  'requerimento_beneficio': 'requerimento_beneficio',
  'emenda_inicial_previdenciario': 'emenda_inicial_previdenciario',
  'contestacao_previdenciario': 'contestacao_previdenciario',
  'replica_previdenciario': 'replica_previdenciario',
  'manifestacao_previdenciario': 'manifestacao_previdenciario',
  'producao_provas_previdenciario': 'producao_provas_previdenciario',
  'quesitos_periciais_previdenciario': 'quesitos_periciais_previdenciario',
  'alegacoes_finais_previdenciario': 'alegacoes_finais_previdenciario',
  'recurso_inominado_previdenciario': 'recurso_inominado_previdenciario',
  'apelacao_previdenciario': 'apelacao_previdenciario',
  'contrarrazoes_apelacao_previdenciario': 'contrarrazoes_apelacao_previdenciario',
  'agravo_instrumento_previdenciario': 'agravo_instrumento_previdenciario',
  'contraminuta_agravo_previdenciario': 'contraminuta_agravo_previdenciario',
  'agravo_interno_previdenciario': 'agravo_interno_previdenciario',
  'contraminuta_agravo_interno_previdenciario': 'contraminuta_agravo_interno_previdenciario',
  'cumprimento_sentenca_previdenciario': 'cumprimento_sentenca_previdenciario',
  'impugnacao_cumprimento_previdenciario': 'impugnacao_cumprimento_previdenciario',
  'impugnacao_homologacao_previdenciario': 'impugnacao_homologacao_previdenciario',
  'memoriais_previdenciario': 'memoriais_previdenciario',
  'memoriais_stj_previdenciario': 'memoriais_stj_previdenciario',
  'recurso_especial_previdenciario_judicial': 'recurso_especial_previdenciario_judicial',
  'contrarrazoes_resp_previdenciario': 'contrarrazoes_resp_previdenciario',
  'recurso_extraordinario_previdenciario': 'recurso_extraordinario_previdenciario',
  'contrarrazoes_re_previdenciario': 'contrarrazoes_re_previdenciario',
  'agravo_resp_previdenciario': 'agravo_resp_previdenciario',
  'contraminuta_agravo_resp_previdenciario': 'contraminuta_agravo_resp_previdenciario',
  'recurso_ordinario_constitucional_previdenciario': 'recurso_ordinario_constitucional_previdenciario',
  'mandado_seguranca_previdenciario': 'mandado_seguranca_previdenciario',
  'rpv_previdenciario': 'rpv_previdenciario',
  'peca_modelo_previdenciario': 'peca_modelo_previdenciario',

  // ========================================
  // TRÂNSITO
  // ========================================
  'defesa_previa_detran': 'defesa_previa_detran',
  'recurso_jari': 'recurso_jari',
  'recurso_cetran': 'recurso_cetran',
  'manifestacao_transito': 'manifestacao_transito',
  'peticao_inicial_transito': 'peticao_inicial_transito',
  'contraminuta_agravo_transito': 'contraminuta_agravo_transito',
  'contrarrazoes_resp_transito': 'contrarrazoes_resp_transito',
  'contrarrazoes_re_transito': 'contrarrazoes_re_transito',
  'contrarrazoes_ed_transito': 'contrarrazoes_ed_transito',
  'contrarrazoes_apelacao_transito': 'contrarrazoes_apelacao_transito',
  'embargos_declaracao_transito': 'embargos_declaracao_transito',
  'embargos_terceiro_transito': 'embargos_terceiro_transito',
  'excecao_pre_executividade_transito': 'excecao_pre_executividade_transito',
  'replica_transito': 'replica_transito',
  'impugnacao_cumprimento_transito': 'impugnacao_cumprimento_transito',
  'impugnacao_embargos_execucao_transito': 'impugnacao_embargos_execucao_transito',
  'impugnacao_homologacao_transito': 'impugnacao_homologacao_transito',
  'execucao_titulo_transito': 'execucao_titulo_transito',
  'mandado_seguranca_transito': 'mandado_seguranca_transito',
  'manifestacao_impugnacao_embargos_transito': 'manifestacao_impugnacao_embargos_transito',
  'producao_provas_transito': 'producao_provas_transito',
  'recurso_especial_transito': 'recurso_especial_transito',
  'recurso_extraordinario_transito': 'recurso_extraordinario_transito',
  'recurso_inominado_transito': 'recurso_inominado_transito',
  'agravo_instrumento_transito': 'agravo_instrumento_transito',
  'quesitos_periciais_transito': 'quesitos_periciais_transito',
  'memoriais_transito': 'memoriais_transito',
  'peca_modelo_transito': 'peca_modelo_transito',
  'recurso_ordinario_constitucional_transito': 'recurso_ordinario_constitucional_transito',

  // ========================================
  // MAGISTRATURA
  // ========================================
  'acordao': 'acordao',
  'decisao_judicial': 'decisao_judicial',
  'sentenca': 'sentenca',

  // ========================================
  // RECESSO
  // ========================================
  'indulto_natalino_recesso': 'indulto_natalino_recesso',
  'sustacao_protesto_recesso': 'sustacao_protesto_recesso',
  'busca_apreensao_menor_recesso': 'busca_apreensao_menor_recesso',
  'contranotificacao': 'contranotificacao',
  'habeas_corpus_recesso': 'habeas_corpus_recesso',
  'impugnacao_penhora_recesso': 'impugnacao_penhora_recesso',
  'adjudicacao_compulsoria_recesso': 'adjudicacao_compulsoria_recesso',
  'mandado_seguranca_recesso': 'mandado_seguranca_recesso',
  'manifestacao_recesso': 'manifestacao_recesso',
  'notificacao_extrajudicial': 'notificacao_extrajudicial',
  'cumprimento_provisorio_recesso': 'cumprimento_provisorio_recesso',
  'rpv_recesso': 'rpv_recesso',
  'levantamento_valores': 'levantamento_valores',
  'liberdade_provisoria_recesso': 'liberdade_provisoria_recesso',
  'penhora_faturamento': 'penhora_faturamento',
  'penhora_rosto_autos': 'penhora_rosto_autos',
  'relaxamento_prisao_recesso': 'relaxamento_prisao_recesso',
  'revogacao_preventiva_recesso': 'revogacao_preventiva_recesso',
  'revogacao_preventiva_medidas_recesso': 'revogacao_preventiva_medidas_recesso',
  'peticao_incidente_recesso': 'peticao_incidente_recesso',
  'tutela_antecipada_antecedente': 'tutela_antecipada_antecedente',
  'tutela_cautelar_antecedente': 'tutela_cautelar_antecedente',
  'tutela_antecipada_incidental': 'tutela_antecipada_incidental',
  'tutela_evidencia_recesso': 'tutela_evidencia_recesso',
  'tutela_cautelar_incidental': 'tutela_cautelar_incidental',
  
  // Contratos
  'elaborar_contrato': 'criar_contrato',
  'revisar_contrato': 'revisar_contrato',
  'analise_contrato_parecer': 'analise_contrato_parecer',
  'analise_negociacao': 'analise_negociacao',
  'analise_risco_rescisao': 'analise_risco_rescisao',
  'comparar_contratos': 'comparar_contratos',
  'criar_aditivo': 'criar_aditivo',
  'criar_clausula': 'criar_clausula',
  'termo_encerramento': 'termo_encerramento',
  'termos_uso': 'termos_uso',
  'contrato_modelo': 'contrato_modelo',
  
  // Extrajudicial (formulários novos)
  'testamento_particular': 'testamento_particular',
};

// Tipos de documento que têm formulário específico
export const SPECIFIC_FORM_TYPES = Object.keys(FORM_TYPE_MAPPING);

// Função helper para verificar se tem formulário específico
export const hasSpecificForm = (documentTypeId: string): boolean => {
  return SPECIFIC_FORM_TYPES.includes(documentTypeId);
};

// Função helper para obter o tipo de formulário
export const getFormType = (documentTypeId: string): string | null => {
  return FORM_TYPE_MAPPING[documentTypeId] || null;
};

